<template>
  <div class="apply">

    <div class="apply-top">
      <van-nav-bar title="投递记录">
        <template #left>
          <van-icon name="arrow-left" size="24" @click="goBack"/>
        </template>
        <template #right>
          <van-icon name="user-circle-o" size="24" @click="toHomePage"/>
        </template>
      </van-nav-bar>
    </div>

    <div class="apply-body">
      <van-skeleton :loading="loading" :row="3" :style="{ paddingTop: '16px' }">
        <van-empty v-if="dataList.length < 1" description="暂无投递记录" />
        <van-cell-group v-if="dataList.length > 0">
          <van-cell v-for="data in dataList" :key="data"
                    :title="data['job']['title']"
                    :label="parseTimeStr(data['createtime'])">
            <template #value>
              <van-row justify="end">
                <span>{{ data['job']['city'] }}</span>
              </van-row>
              <van-row justify="end" style="font-size: 10px;">
                <span>{{ data['job']['company'] }}</span>
              </van-row>
            </template>
          </van-cell>
        </van-cell-group>
      </van-skeleton>
    </div>

  </div>
</template>

<script>
import {getResumeListByUser} from "@/api";
import {showNotify} from "vant";
import {parseTime} from "@/api/common";

export default {
  name: "ResumeList",
  data() {
    return {
      loading: true,
      dataList: [],
      userId:'',
      city: '',
      typeId: 0,
      keyword: '',
      cityOption: [],
      typeOption: [],
    }
  },
  mounted() {
    this.userId = this.$route.params['userId'];
    this.loading = true;
    getResumeListByUser().then((res) => {
      if (res.code === 200) {
        this.dataList = res.data;
        this.loading = false;
      } else {
        showNotify({ type: 'danger', message: '服务器繁忙，请稍后再试。', position: 'bottom' });
      }
    });
  },
  methods: {
    goBack() {
      window.history.back();
    },
    toHomePage() {
      this.$router.push('/HomePage');
      window.sessionStorage.setItem('back', '/JobList');
    },
    parseTimeStr(time, pattern) {
      return parseTime(time, pattern);
    },
  }
}
</script>

<style scoped>
.apply {
  width:100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.apply-top {
  background-color: rgb(248,248,248);
  padding-bottom: 10px;
}

.apply-body {
  flex: 1;
  overflow-y: scroll;
  padding-bottom: 20px;
}

/deep/ .van-hairline--bottom:after {
  border: none;
}

/deep/ .van-dropdown-menu__bar {
  box-shadow: none;
}

/deep/ .van-dropdown-menu__bar--opened {
  box-shadow: 0 2px 12px rgba(100, 101, 102, .12);
}

/deep/ .van-cell__title {
  min-width: 50%;
}

/deep/ .van-cell__value {
  min-width: 50%;
}

/deep/ .van-hairline--top-bottom:after {
  border: none;
}
</style>